export enum MapperRunStatus {
    NotStarted = '',
    Started = 'Started',
    Starting = 'Starting',
    Stopped = 'Stopped',
    Stopping = 'Stopping',
    Failed = 'Failed'
}
